export default function authHeader(users) {
  const currentToken = localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : "";

  //console.log(currentToken);
  if (currentToken && currentToken) {
    return {
      "Access-Control-Allow-Origin": "*",
      authorization: `Bearer ${currentToken}`,
    };
  } else {
    return {};
  }
}
